import React from 'react'

function RegisterResultForm() {
  return (
    <div>RegisterResultForm</div>
  )
}

export default RegisterResultForm

// import React, { useEffect, useState } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { useTranslation } from 'react-i18next';
// import DangerButton from '../common/DangerButton';
// // import Points from 'user/Points';
// // import { getPoint } from '@/redux/actions/userActions';

// const RegisterResultForm = () => {
//   const { t } = useTranslation();
//   const dispatch = useDispatch();

//   const point = useSelector((state) => state.user.point);
//   const totalGamePoint = useSelector((state) => state.authen.totalGamePoint);
//   const seniorLayout = useSelector((state) => state.user.seniorLayout);

//   useEffect(() => {
//     // dispatch(getPoint());
//   }, [dispatch]);

//   return (
//     <div
//       className={`w-full h-full flex flex-col items-center text-center py-10 ${seniorLayout ? '' : 'px-5 sm:px-2 xs:px-1'}`}
//     >
//       <div className={`w-full font-medium ${seniorLayout ? 'text-26' : 'text-3xl'}`}>
//         {t('register_succeeded')}
//       </div>
//       <img src="/assets/images/bigpoint-success-icon.png" alt="Success" className="w-64 py-2" />
//       <div className={`w-72 font-normal ${seniorLayout ? '-mt-3 text-base' : 'text-lg'}`}>
//         {t('register_succeeded_desc')}
//       </div>
//       {/* <Points className={seniorLayout ? 'mt-5' : 'mt-8'} point={point} gamePoint={totalGamePoint} /> */}
//       <div className={`w-48 h-13 self-center ${seniorLayout ? 'mt-8' : 'mt-11'}`}>
//         <DangerButton buttonName={t('login')} />
//       </div>
//     </div>
//   );
// };

// export default RegisterResultForm;